var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstapapper = function SvgInstapapper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.875 2.17c.32-.28.78-.46 2.07-.53a.5.5 0 0 0 .48-.5V.5a.5.5 0 0 0-.55-.5h-10a.5.5 0 0 0-.5.5v.64a.5.5 0 0 0 .48.5c1.29.07 1.75.25 2.07.53.17.15.45.62.45 2.1v15.46c0 1.64-.33 2-.43 2.1a3.8 3.8 0 0 1-2.07.53.49.49 0 0 0-.46.49v.65a.5.5 0 0 0 .46.5h10a.5.5 0 0 0 .5-.5v-.65a.49.49 0 0 0-.46-.49 3.67 3.67 0 0 1-2.11-.54c-.1-.07-.43-.45-.43-2.09V4.27c0-1.47.28-1.95.5-2.1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.875 0h24v24h-24z"
  })))));
};
export default SvgInstapapper;